import { type User } from '../types';
import { createContext } from 'react';

// TODO not nullable?
const PortfolioUserContext = createContext<User | null>(null);

export default PortfolioUserContext;
